export const PAGINATION = {
  DISPLAYED_PAGE: 'COMMON_COMMON_DISPLAYED_PAGE',
  NEXT: 'COMMON_COMMON_NEXT',
  PREVIOUS: 'COMMON_COMMON_PREVIOUS',
};
